import { render, staticRenderFns } from "./announce_procedure_buy_declined_ru.vue?vue&type=template&id=4952bef2&scoped=true"
import script from "./announce_procedure_buy_declined_ru.vue?vue&type=script&lang=js"
export * from "./announce_procedure_buy_declined_ru.vue?vue&type=script&lang=js"
import style0 from "./announce_procedure_buy_declined_ru.vue?vue&type=style&index=0&id=4952bef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952bef2",
  null
  
)

export default component.exports